import { render, staticRenderFns } from "./your-library-artists.vue?vue&type=template&id=52e69bbf&scoped=true"
import script from "./your-library-artists.vue?vue&type=script&setup=true&lang=js"
export * from "./your-library-artists.vue?vue&type=script&setup=true&lang=js"
import style0 from "./your-library-artists.vue?vue&type=style&index=0&id=52e69bbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e69bbf",
  null
  
)

export default component.exports